package uk.co.nickthecoder.kyd.appearance

import uk.co.nickthecoder.glok.backend.backend
import uk.co.nickthecoder.glok.property.boilerplate.colorProperty
import uk.co.nickthecoder.glok.scene.Color
import uk.co.nickthecoder.glok.util.Matrix
import uk.co.nickthecoder.kyd.util.Vector2

class GraphicAppearance(val graphic: Graphic) : TintedAppearance {

    override val tintProperty by colorProperty(Color.WHITE)
    override var tint by tintProperty

    override fun draw(modelMatrix: Matrix) {
        val w = graphic.width.toFloat()
        val h = graphic.height.toFloat()
        // NOTE. We are using Glok's backend to draw the texture, which has the Y axis pointing DOWNWARDS,
        // so we adjust accordingly
        backend.drawTintedTexture(
            graphic.texture,
            tint,
            0f, 0f, w, h,
            - graphic.pin.x, graphic.pin.y, w, - h,
            modelMatrix
        )
    }

    override fun localCorners(): List<Vector2> {
        val x1 = - graphic.pin.x
        val x2 = x1 + graphic.width
        val y1 = graphic.pin.y
        val y2 = y1 - graphic.height

        return listOf(
            Vector2(x1, y1),
            Vector2(x2, y1),
            Vector2(x2, y2),
            Vector2(x1, y1)
        )
    }

    override fun localBounds() = Pair(
        Vector2(- graphic.pin.x, graphic.pin.y),
        Vector2(- graphic.pin.x + graphic.width, graphic.pin.y - graphic.height)
    )

    override fun containsLocalPoint(localPoint: Vector2): Boolean {
        val fromLeft = localPoint.x + graphic.pin.x
        if (fromLeft < 0 || fromLeft >= graphic.width) return false

        val fromTop = graphic.pin.y - localPoint.y
        return fromTop >= 0 && fromTop < graphic.height
    }
}
